import { urlMaker } from 'modules/utils/urlMaker'

export const commonEndpoints = {
  //
  //Auth
  login: () => '/auth/login/',
  loginCRM: () => '/auth/crm-login/',
  getCode: () => '/auth/get_code/',
  refreshToken: () => '/auth/token-refresh/',

  //Positions
  positions: () => `/positions/`,
  totalsPositions: () => `/positions/totals/`,

  //
  //Geo
  countries: () => `/geo/countries/`,
  provinces: () => '/geo/provinces/',
  districts: () => '/geo/districts/',

  //
  //Events
  eventsCount: urlMaker('/events/count/'),
  getEventChannel: urlMaker('/events/get-channel/'),
  pusherAuthEndpoint: urlMaker('/events/auth/'),
  markEventAsRead: urlMaker('/events/object-events-viewed/'),

  //
  //Samples
  samples: urlMaker('/samples/'),
  sampleRequest: urlMaker('/samples/requests/'),
  completeSampleRequest: (sampleId) => `/samples/${sampleId}/complete-request/`,
  sampleRequestDocuments: (requestId: string, docId?: string) =>
    `/samples/requests/${requestId}/documents/${docId ? `${docId}/` : ''}`,
  sampleRequestForDeal: urlMaker('/samples/requests/for-deal/'),
  samplesStatus: () => `/samples/statuses/`,
  sampleComments: (sampleId: number) => `/samples/${sampleId}/comments/`,
  sampleFiles: (sampleId: string, fileId?: string) => `/samples/${sampleId}/files/${fileId ? `${fileId}/` : ''}`,
  cancelSample: (sampleId: string) => `/samples/${sampleId}/cancel-request/`,
  labs: () => '/samples/labs/',
  samplePartsAsExcel: (sampleId: string) => `/samples/parts/${sampleId}/as-excel/`,
  samplePartsAsJson: (sampleId: string) => `/samples/parts/${sampleId}/as-json/`,

  samplesDataForExportBot: (sampleId: string) => `/samples/publishing-to-export-chat/${sampleId}/get-message-data/`,
  samplesDataForExportBotFromHistory: (sampleId: string) =>
    `/samples/publishing-to-export-chat/${sampleId}/get-message-data-from-history/`,
  samplesForExportBotPreview: (sampleId: string) => `/samples/publishing-to-export-chat/${sampleId}/preview/`,
  samplesForExportBotSend: (sampleId: string) => `/samples/publishing-to-export-chat/${sampleId}/send/`,

  samplesDataForLocalBot: (sampleId: string) => `/samples/publishing-to-local-chat/${sampleId}/get-message-data/`,
  samplesDataForLocalBotFromHistory: (sampleId: string) =>
    `/samples/publishing-to-local-chat/${sampleId}/get-message-data-from-history/`,
  samplesForLocalBotPreview: (sampleId: string) => `/samples/publishing-to-local-chat/${sampleId}/preview/`,
  samplesForLocalBotSend: (sampleId: string) => `/samples/publishing-to-local-chat/${sampleId}/send/`,
  sampleRequestResume: (sampleRequestId: string) => `/samples/requests/${sampleRequestId}/resume/`,
  sampleRequestPause: (sampleRequestId: string) => `/samples/requests/${sampleRequestId}/pause/`,
  sampleReactionStats: () => `/samples/reaction-stats/`,

  //
  //Taxes

  priceCalculator: () => `/taxes/grain_price_calculator/`,
  dealTaxCalculation: (dealId: string) => `/taxes/calculation/${dealId}`,

  //
  //Catalog

  seasonsList: (productId = '') => `/catalog/seasons/?product=${productId}`,

  //
  //Files
  files: urlMaker('/files/'),
  // webp files if uploaded here will be converted to png
  filesAsPng: urlMaker('/files/as-png/'),

  documentIndex: () => '/doc-index/',
  documentIndexModels: () => '/doc-index/models/',
  documentIndexDocumentTypes: () => '/doc-index/document-types/',

  //
  //Logs

  logs: () => '/logs/contacts/',

  signReport: () => '/analytics/sign-report/',
}
